import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Lucía', 'Javier', 'Sofía', 'Diego', 'Valentina', 'Andrés', 'Camila', 'Fernando'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'San Miguel de Tucumán', 'Santa Fe', 'San Juan'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showNewNotification();
    }, 4000);
    const showNewNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
        // Schedule next notification (random between 8-12 seconds after hiding)
        const nextDelay = Math.floor(Math.random() * 4000) + 8000;
        setTimeout(showNewNotification, nextDelay);
      }, 5000);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-274">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      x: -20
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50 max-w-xs w-full" data-id="element-275">
          <div className="bg-white rounded-lg shadow-lg border-l-4 border-[#FF6B35] p-4 flex items-center gap-3" data-id="element-276">
            <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-277">
              <CheckCircle className="w-5 h-5 text-green-600" data-id="element-278" />
            </div>
            <div data-id="element-279">
              <p className="text-sm font-medium text-gray-900" data-id="element-280">
                <span className="font-bold" data-id="element-281">{data.name}</span> de {data.city}
              </p>
              <p className="text-xs text-gray-600" data-id="element-282">
                compró{' '}
                <span className="font-semibold text-[#0077B6]" data-id="element-283">
                  Llegar Justo Otra Vez
                </span>
              </p>
              <p className="text-[10px] text-gray-400 mt-1" data-id="element-284">
                Hace unos instantes
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}